import { render } from "./SuiviData.vue?vue&type=template&id=1e187678&scoped=true"
import script from "./SuiviData.vue?vue&type=script&lang=js"
export * from "./SuiviData.vue?vue&type=script&lang=js"

import "./SuiviData.vue?vue&type=style&index=0&id=1e187678&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e187678"]])

export default __exports__